export default __webpack_public_path__ + "static/media/TELMOL-Logo-transparent-01.d04f8029.png";